import '@/lib/viewPoint'
import './pc.css'
import { initTemplateTranslate } from '@/utils/translate'
import {activeModules,activeLazyImage} from './lib/lazy'
import initDomains from '@/lib/initDomain'

initDomains()
activeModulesWithLocal()
activeLazyImage()

async function activeModulesWithLocal(){
	await initTemplateTranslate()
	activeModules(Array.from(document.querySelectorAll(".j-module")))
}